import React from 'react';

const StatsSection = () => {
  return (
    <div className="row justify-content-center mt-0 mx-0 pb-0 pt-0 pt-lg-2">
      <div className="col-12 col-md-10 col-lg-8 px-4">
        <div className="new-demo-stats-container d-flex flex-column flex-md-row justify-content-around align-items-center text-center w-100 p-4 p-md-4">
          <div className="new-demo-stat-item mb-4 mb-md-0">
            <h2>500+</h2>
            <p>Happy Users</p>
          </div>
          <div className="new-demo-stat-item mb-4 mb-md-0">
            <h2>50k+</h2>
            <p>Images Generated</p>
          </div>
          <div className="new-demo-stat-item">
            <h2>&lt; 1 min</h2>
            <p>Per Generation</p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default StatsSection;
